import * as Sentry from '@sentry/react';

interface LogContext {
  [key: string]: unknown;
}

function createLogger(namespace?: string) {
  const prefix = namespace ? `[${namespace}]` : '';

  return {
    debug(message: string, context?: LogContext) {
      if (import.meta.env.DEV) {
        console.debug(prefix, message, context ?? '');
      }
      Sentry.logger.debug(`${prefix} ${message}`, context);
    },

    info(message: string, context?: LogContext) {
      if (import.meta.env.DEV) {
        console.info(prefix, message, context ?? '');
      }
      Sentry.logger.info(`${prefix} ${message}`, context);
    },

    warn(message: string, context?: LogContext) {
      console.warn(prefix, message, context ?? '');
      Sentry.logger.warn(`${prefix} ${message}`, context);
      Sentry.addBreadcrumb({
        category: namespace ?? 'app',
        message,
        level: 'warning',
        data: context,
      });
    },

    error(message: string, error?: Error | unknown, context?: LogContext) {
      console.error(prefix, message, error, context ?? '');
      Sentry.logger.error(`${prefix} ${message}`, context);

      if (error instanceof Error) {
        Sentry.captureException(error, {
          tags: { namespace },
          extra: { message, ...context },
        });
      } else {
        Sentry.captureMessage(`${prefix} ${message}`, {
          level: 'error',
          extra: { error, ...context },
        });
      }
    },
  };
}

const logger = createLogger();

export { createLogger, logger };
